import { API_BASE } from '../config/api';
// ============================================
// HELPERSCLIENTES.JS — Constantes y helpers para fichas
// ============================================

export const API_BASE_CLI = API_BASE;   // direccion del backend: config/api.js (fuente unica)
export const PP = "'Poppins', sans-serif";
export const COLOR_PRINCIPAL = '#5E99D2'; // blue-500 accent (paleta Beep / --color-accent)
export const COLOR_OSCURO = '#265F97'; // blue-700 primario (paleta Beep / --color-primary)
export const COLOR_FONDO = '#f3f4f4';
export const COLOR_GRIS = '#4e5357';
export const COLOR_GRIS_CLARO = '#6b7280';
export const COLOR_BORDE = '#e6e8ea';
export const COLOR_ADVERTENCIA = '#f4a261';
export const COLOR_EXITO = '#5cd4b0';
export const COLOR_ERROR = '#e05c5c';

export const ESTADOS_CLIENTE = {
  basico:         { color: '#e05c5c', label: 'Básico' },
  operativo:      { color: '#f4a261', label: 'Operativo' },
  listo_facturar: { color: '#5cd4b0', label: 'Listo para facturar' },
  archivado:      { color: '#b0b4b8', label: 'Archivado' },
};

export const TIPOS_ROL = {
  administrador:       { label: 'Administrador',         color: '#5c9adb' },
  gerente:             { label: 'Gerente',               color: '#a78bfa' },
  encargado_sucursal:  { label: 'Encargado de sucursal', color: '#5cd4b0' },
};

// Áreas/especialidades del rol 'administrador' (antes 'tomador_decision').
export const AREAS_TOMADOR = [
  { id: 'sistemas',    label: 'Sistemas' },
  { id: 'seguridad',   label: 'Seguridad' },
  { id: 'compras',     label: 'Compras' },
  { id: 'operaciones', label: 'Operaciones' },
  { id: 'direccion',   label: 'Dirección' },
  { id: 'otro',        label: 'Otro' },
];

export const ESTADOS_ROL = {
  activo_confirmado:     { label: 'Activo',        color: '#5cd4b0' },
  nuevo_por_confirmar:   { label: 'Nuevo',         color: '#5c9adb' },
  posiblemente_inactivo: { label: 'Posiblemente inactivo', color: '#f4a261' },
  historico:             { label: 'Histórico',     color: '#b0b4b8' },
};

// Estilos reutilizables
export const estiloInput = {
  width: '100%', padding: '8px 10px', border: `1px solid ${COLOR_BORDE}`,
  // outline:none mata el contorno por defecto del navegador; el foco visible
  // lo provee la regla global :focus-visible (con !important) del bloque <style> de Tienda.
  borderRadius: 6, fontSize: 13, fontFamily: PP, outline: 'none',
  boxSizing: 'border-box', background: '#fff',
};

export const estiloBotonPrimario = {
  background: COLOR_PRINCIPAL, color: '#fff', border: 'none',
  padding: '8px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
  cursor: 'pointer', fontFamily: PP,
};

export const estiloBotonSecundario = {
  background: '#fff', color: COLOR_GRIS, border: `1px solid ${COLOR_BORDE}`,
  padding: '8px 14px', borderRadius: 8, fontSize: 12, fontWeight: 500,
  cursor: 'pointer', fontFamily: PP,
};

export const estiloTarjeta = {
  background: '#fff', border: `1px solid ${COLOR_BORDE}`, borderRadius: 10, padding: 16,
};

export function PuntoEstado({ estado, tamano = 10 }) {
  const e = ESTADOS_CLIENTE[estado] || ESTADOS_CLIENTE.basico;
  return (
    <span
      title={e.label}
      style={{
        display: 'inline-block', width: tamano, height: tamano, borderRadius: '50%',
        background: e.color, flexShrink: 0,
      }}
    />
  );
}

export function CabeceraFicha({ volver, titulo, subtitulo, estado, acciones }) {
  return (
    // flexWrap (Sprint Sucursales 1, hallazgo de Don Porfirio): con 2+ botones de
    // accion en movil, las acciones bajan a una segunda fila en vez de aplastar
    // el titulo (que es el dato principal de la ficha).
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '16px 24px',
      background: '#fff', borderBottom: `1px solid ${COLOR_BORDE}`, flexWrap: 'wrap',
    }}>
      <button
        onClick={volver}
        style={{
          background: 'transparent', border: 'none', fontSize: 18, cursor: 'pointer',
          color: COLOR_OSCURO, padding: 0,
        }}
        title="Volver"
      >
        ←
      </button>
      <div style={{ flex: 1, minWidth: 0, flexBasis: 200 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: COLOR_OSCURO, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {titulo}
          </div>
          {estado && <PuntoEstado estado={estado} />}
        </div>
        {subtitulo && <div style={{ fontSize: 12, color: COLOR_GRIS_CLARO, marginTop: 2 }}>{subtitulo}</div>}
      </div>
      {acciones}
    </div>
  );
}

// Devuelve una lista de campos faltantes con sus etiquetas. Útil para mostrar "pendientes".
export function faltantesRazonSocial(rs) {
  const faltan = [];
  if (!rs.rfc) faltan.push('RFC');
  if (!rs.regimen_sat) faltan.push('Régimen SAT');
  if (!rs.domicilio_fiscal) faltan.push('Domicilio fiscal');
  if (!rs.codigo_postal_fiscal) faltan.push('Código postal fiscal');
  if (!rs.email_facturacion) faltan.push('Email de facturación');
  return faltan;
}

export function faltantesSucursal(s) {
  const faltan = [];
  if (!s.direccion) faltan.push('Dirección');
  if (s.latitud == null || s.longitud == null) faltan.push('Coordenadas GPS');
  if (!s.ciudad) faltan.push('Ciudad');
  return faltan;
}
